<template>
  <div :class="$style.container">
    <slot />
  </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.container {
  padding: $size-grid-padding;
  margin-bottom: $size-grid-padding;
  background: white;
  border-radius: 2px;
  box-shadow:
    0 2px 2px 0 rgb(0 0 0 / 16%),
    0 0 0 1px rgb(0 0 0 / 8%);

  > :first-child {
    margin-top: -40px;
  }

  > :last-child {
    margin-bottom: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
